import { ensureGuestInfoShape } from './guestUtils';

export const normalizeRegistration = (raw) => {
    const KNOWN = new Set(['confirmed', 'waitlist', 'cancelled']);
    const rawStatus = String(raw?.status ?? '').toLowerCase().trim();
    const safeStatus = KNOWN.has(rawStatus) ? rawStatus : 'waitlist';

    const guestObj = raw && typeof raw.guest === 'object' ? raw.guest : null;

    const normalizedGuestInfo =
        ensureGuestInfoShape(raw?.guestInfo) ??
        ensureGuestInfoShape(guestObj) ??
        ((raw?.guestFirstName || raw?.guestLastName || raw?.guestName || raw?.guest_first_name || raw?.guest_last_name)
            ? ensureGuestInfoShape({
                  firstName: raw?.guestFirstName ?? raw?.guest_first_name ?? '',
                  lastName: raw?.guestLastName ?? raw?.guest_last_name ?? '',
                  phone: raw?.guestPhone ?? raw?.guest_phone ?? null,
                  level: raw?.guestLevel ?? raw?.guest_level ?? null,
                  name: raw?.guestName ?? raw?.guest_name ?? '',
              })
            : null);

    return {
        id: raw?.id ?? raw?.registrationId ?? raw?.registration_id ?? null,
        status: safeStatus,
        playerId: raw?.playerId ?? raw?.player_id ?? null,
        playerName: raw?.playerName ?? raw?.player_name ?? null,
        guestId: raw?.guestId ?? raw?.guest_id ?? (guestObj && (guestObj.id ?? guestObj.guestId ?? guestObj.guest_id)) ?? null,
        guest: guestObj,
        guestInfo: normalizedGuestInfo,
        registeredAt: raw?.registeredAt ?? raw?.registered_at ?? raw?.createdAt ?? raw?.created_at ?? null,
    };
};

export const mergePreservingGuest = (serverRegs, currentRegs) => {
    const byId = new Map((currentRegs ?? []).map((r) => [r.id, r]));
    return (serverRegs ?? []).map((server) => {
        const current = byId.get(server.id);
        if (!current) return server;

        const guest = server.guest ?? current.guest ?? null;
        const guestInfo = server.guestInfo ?? current.guestInfo ?? null;
        return { ...server, guest, guestInfo };
    });
};

const KNOWN_STATUSES = ['confirmed', 'waitlist', 'cancelled'];
const hasValue = (value) => value != null && value !== '';

export const groupRegistrationsByStatus = (registrations = []) => {
    const map = { confirmed: [], waitlist: [], cancelled: [] };
    const knownStatuses = new Set(KNOWN_STATUSES);

    for (const registration of registrations) {
        const rawStatus = String(registration?.status ?? '').toLowerCase().trim();
        const normalizedStatus = knownStatuses.has(rawStatus) ? rawStatus : 'waitlist';
        (map[normalizedStatus] || (map[normalizedStatus] = [])).push(registration);
    }

    return map;
};

export const countRegistrationParticipants = (registration) => {
    if (!registration || typeof registration !== 'object') return 0;

    const hasPlayer = hasValue(registration.playerId ?? registration.player_id);
    const guestObj = registration && typeof registration.guest === 'object' ? registration.guest : null;
    const guestInfoRaw =
        registration?.guestInfo ??
        guestObj ??
        ((hasValue(registration?.guestFirstName ?? registration?.guest_first_name) ||
            hasValue(registration?.guestLastName ?? registration?.guest_last_name) ||
            hasValue(registration?.guestName ?? registration?.guest_name))
            ? {
                firstName: registration?.guestFirstName ?? registration?.guest_first_name ?? '',
                lastName: registration?.guestLastName ?? registration?.guest_last_name ?? '',
                phone: registration?.guestPhone ?? registration?.guest_phone ?? null,
                level: registration?.guestLevel ?? registration?.guest_level ?? null,
                name: registration?.guestName ?? registration?.guest_name ?? '',
            }
            : null);

    const normalizedGuestInfo = ensureGuestInfoShape(guestInfoRaw);

    const hasGuestId = hasValue(registration.guestId ?? registration.guest_id);
    const hasGuestInfo = Boolean(
        normalizedGuestInfo &&
        (hasValue(normalizedGuestInfo.firstName) ||
            hasValue(normalizedGuestInfo.lastName) ||
            hasValue(normalizedGuestInfo.name))
    );

    const guestSlots = hasGuestId || hasGuestInfo ? 1 : 0;
    const playerSlots = hasPlayer ? 1 : 0;

    if (guestSlots === 0 && playerSlots === 0) return 0;

    return guestSlots + playerSlots;
};

export const countParticipants = (registrations = []) =>
    registrations.reduce((total, registration) => total + countRegistrationParticipants(registration), 0);

export const buildStatusSections = (registrationsByStatus) => {
    const base = [
        { key: 'confirmed', title: 'Confirmadas' },
        { key: 'waitlist', title: 'Lista de espera' },
    ];

    if ((registrationsByStatus?.cancelled ?? []).length > 0) {
        return [...base, { key: 'cancelled', title: 'Bajas' }];
    }

    return base;
};
